import React from "react";
import "../../assets/css/CorporateCustomers.css";

const customers = [
    "ts",
    "synclevis",
    "bop",
    "messe-stuttgart",
    "theka",
    "stanza-living",
    "elevate",
    "kpmg",
    "antara",
    "absstem",
    "shaadi",
    "learnapp",
];

// duplicate for infinite scroll
const sliderData = [...customers, ...customers];

const CorporateCustomers = () => {
    return (
        <section className="cc-section">
            <h2 className="cc-heading">Our Corporate Customers</h2>

            {/* 🔹 TOP ROW */}
            <div className="cc-viewport">
                <div className="cc-track cc-left">
                    {sliderData.map((logo, index) => (
                        <div className="cc-card" key={`top-${index}`}>
                            <img src={`/logos/${logo}.png`} alt={logo} loading="lazy" />
                        </div>
                    ))}
                </div>
            </div>

            {/* 🔹 BOTTOM ROW */}
            <div className="cc-viewport cc-gap">
                <div className="cc-track cc-right">
                    {sliderData.map((logo, index) => (
                        <div className="cc-card" key={`bottom-${index}`}>
                            <img src={`/logos/${logo}.png`} alt={logo} loading="lazy" />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CorporateCustomers;
